import script from "./PublicForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicForm.vue?vue&type=script&setup=true&lang=js"

import "./PublicForm.vue?vue&type=style&index=0&id=debe44c8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-debe44c8"]])

export default __exports__